export default __webpack_public_path__ + "static/media/modernLoteryLogo.9142ea28.png";